import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { cloneDeep } from 'lodash';
var initForm = {};
export default {
  meta: {
    title: '角色管理',
    auth: true,
    authorityValue: "store-account-management"
  },
  name: 'role',
  data: function data() {
    return {
      initForm: initForm,
      form: cloneDeep(initForm),
      request: {
        api: 'positions',
        params: cloneDeep(initForm)
      }
    };
  },
  methods: {
    handleSearch: function handleSearch(values) {
      this.$set(this.request, 'params', values);
      this.$refs.baseTable.loadData();
    },
    clickDel: function clickDel(data) {
      var _this = this;

      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.deletePosition(data);

              case 2:
                YL.message('成功删除');

                _this.handleSearch();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    onAdd: function onAdd(row) {
      var _this2 = this;

      this.$prompt('角色名称', '添加角色', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '请填写名称'
      }).then( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2) {
          var value;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  value = _ref2.value;
                  _context2.next = 3;
                  return _this2.$api.savePosition({
                    positionName: value
                  });

                case 3:
                  YL.message('添加成功');

                  _this2.handleSearch();

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    onEdit: function onEdit(row) {
      var _this3 = this;

      this.$prompt('角色名称', '编辑角色', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '请填写名称',
        inputValue: row.positionName
      }).then( /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref4) {
          var value;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  value = _ref4.value;
                  _context3.next = 3;
                  return _this3.$api.savePosition({
                    positionName: value,
                    positionId: row.positionId
                  });

                case 3:
                  YL.message('修改成功');

                  _this3.handleSearch();

                case 5:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x2) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }
};